import { Modal } from "antd";
import React from "react";
import { Messages } from "../CommonMessages";

const adnYesNoModal = (
  handleOk,
  title = Messages.DeleteQuestion,
  okType = "danger",
  content = null
) => {
  const { confirm } = Modal;
  return confirm({
    title: title,
    content: content,
    okText: "Yes",
    okType: okType,
    cancelText: "No",
    maskClosable: true,
    onOk() {
      handleOk();
    },
  });
};
export default adnYesNoModal;
